import vars from '../root';

export const styles = {
  container: {
    marginTop: 50,
  },
  cursor_pointer: {
    cursor: 'pointer',
  },
  cream_back: {
    backgroundColor: vars.CREAM,
  },
  yellow_color: {
    color: vars.YELLOW,
  },
  colorOrange: {
    color: vars.ORANGE,
  },
  colorGray: {
    color: vars.DARK_SILVER,
  },
  colorOrangeRed: {
    color: vars.ORANGE_RED,
  },
  colorGreen: {
    color: vars.GREEN,
  },
  colorWhite: {
    color: vars.WHITE,
  },
  fontSize11: {
    fontSize: 11,
  },
  fontSize17: {
    fontSize: 17,
  },
  fontSize20: {
    fontSize: 20,
  },
  fontSize22: {
    fontSize: 22,
  },
  fontSize25: {
    fontSize: 25,
  },
  FontWeight600: {
    fontWeight: 600,
  },
  blackColor: {
    color: 'black',
    fontFamily: 'IRANSans',
  },
  alignItemsCenter: {
    alignItems: 'center',
  },
  alignSelfStart: {
    alignSelf: 'flex-start',
  },
  textCenter: {
    textAlign: 'center',
  },
  textJustify: {
    textAlign: 'justify',
  },
  placeSelfCenter: {
    placeSelfCenter: 'center',
  },
  margin20: {
    marginLeft: 20,
    marginTop: 20,
  },
  marginTop10: {
    marginTop: 10,
  },
  marginTop20: {
    marginTop: 20,
  },
  marginTop40: {
    marginTop: 40,
  },
  marginTop50: {
    marginTop: 50,
  },
  marginRight15: {
    marginRight: 15,
  },
  marginRight25: {
    marginRight: 25,
  },
  marginRight40: {
    marginRight: 40,
  },
  marginRight60: {
    marginRight: 60,
  },
  marginRight20: {
    marginRight: 20,
  },
  margin25: {
    marginTop: 25,
  },
  margin30: {
    margin: 30,
  },
  marginAuto: {
    margin: 'auto',
  },
  marginLeft5: {
    marginLeft: 5,
  },
  marginLeft15: {
    marginLeft: 15,
  },
  marginBottom20: {
    marginBottom: 20,
  },
  marginBottom50: {
    marginBottom: 100,
  },
  marginTop0: {
    marginTop: 0,
  },
  padding0: {
    padding: 0,
  },
  margin0: {
    margin: 0,
  },
  padding5: {
    padding: 5,
  },
  paddingRight15: {
    paddingRight: 15,
  },
  paddingRight5: {
    paddingRight: 5,
  },
  paddingLeft15: {
    paddingLeft: 15,
  },
  paddingRight30: {
    paddingRight: 30,
  },
  paddingTop10: {
    paddingTop: 10,
  },
  paddingBottomUp5: {
    paddingBottom: 5,
    paddingTop: 5,
  },
  justifyContentSpaceAround: {
    justifyContent: 'space-around',
  },
  justifyContentSpaceBetween: {
    justifyContent: 'space-between',
  },
  justifyContentCenter: {
    justifyContent: 'center',
  },
  justifyContentEnd: {
    justifyContent: 'flex-end',
  },
  justifyContentStart: {
    justifyContent: 'flex-start',
  },
  justifySelfCenter: {
    justifySelf: 'center',
  },
  justifySelfEnd: {
    justifySelf: 'end',
  },
  alignSelfCenter: {
    alignSelf: 'center',
  },
  alignSelfEnd: {
    alignSelf: 'end',
  },
  alignItemsEnd: {
    alignItems: 'end',
  },
  alignItemsStart: {
    alignItems: 'start',
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  zIndex20: {
    zIndex: 20,
  },
  gap0: {
    gap: 0,
  },
  gap5: {
    gap: 5,
  },
  gap7: {
    gap: 7,
  },
  gap10: {
    gap: 10,
  },
  gap30: {
    gap: 30,
  },
  gap50: {
    gap: 50,
  },
  gap60: {
    gap: 60,
  },
  gap100: {
    gap: 100,
  },
  gap15: {
    gap: 15,
  },
  flexDirectionRow: {
    flexDirection: 'row',
  },
  flexWrap: {
    flexWrap: 'wrap',
  },
  whiteSpaceNoWrap: {
    whiteSpace: 'nowrap',
  },
  minWidth200: {
    minWidth: 200,
  },
  width15: {
    width: '15%',
  },
  width20: {
    width: '20%',
  },
  width100: {
    width: '100%',
  },
  width50: {
    width: '50%',
  },
  width80: {
    width: '80%',
  },
  flexNoWrap: {
    flexWrap: 'nowrap',
  },
  fontSize12: {
    fontSize: 12,
  },
  fontSize13: {
    fontSize: 13,
  },
  fontSize15: {
    fontSize: 15,
  },
  fontSize10: {
    fontSize: 10,
  },
  largeIcon: {
    padding: 0,
    width: 38,
    height: 38,
  },
  textDecor: {
    textDecoration: 'line-through 2px',
  },
  padding10: {
    padding: 10,
  },
  padding20: {
    padding: 20,
  },
  padding30: {
    padding: 30,
  },
  margin5: {
    margin: 5,
  },
  margin15: {
    margin: 10,
  },
  BlueBold: isDarkMode => ({
    color: isDarkMode ? vars.COLOR_BASE_CONTENT : vars.LIGHT_COLOR_BASE_CONTENT,
    fontWeight: 600,
  }),
  bold: {
    fontWeight: 600,
  },
  overFlowHidden: {
    overflow: 'hidden',
  },
  boxShadow: {
    boxShadow: '0px 3px 16px 4px rgb(0 0 0 / 16%)',
  },
  borderRadius10: {
    borderRadius: 10,
  },
  borderRadius50: {
    borderRadius: '50%',
  },
  borderBottom1: {
    borderBottom: '1px solid #a6a6a6',
  },
  top0: {
    top: 0,
  },
  bottom0: {
    bottom: 0,
  },
  right0: {
    right: 0,
  },
  left0: {
    left: 0,
  },
  symbol: {
    width: 50,
    height: 50,
  },
  positionAbsolute: {
    position: 'absolute',
  },
  transparentItem: {
    border: '2px solid #000',
  },
  //For commonWeb Box
  circleBoxUp: {
    width: 84,
    height: 86,
    backgroundColor: vars.ORANGE_LIGHT,
    top: '-30px',
    right: '-30px',
    position: 'absolute',
    borderRadius: '50%',
  },
  circleNumberBox: {
    position: 'absolute',
    fontSize: 15,
    bottom: 20,
    left: 20,
    backgroundColor: vars.ORANGE,
    color: vars.WHITE,
    opacity: 1,
    borderRadius: '50%',
    paddingRight: 10,
    paddingLeft: 10,
  },
  circleBoxDown: {
    width: 84,
    height: 86,
    backgroundColor: vars.ORANGE_LIGHT,
    bottom: '-30px',
    left: '-30px',
    position: 'absolute',
    borderRadius: '50%',
  },
};
